import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import LayoutWhite from "../../components/LayoutWhite";

export default function CancelationApplePage() {
  const { t } = useTranslation();

  const appleUrl = "https://support.apple.com/118428";

  return (
    <LayoutWhite>
      <div className="flex h-full flex-col items-center justify-center space-y-8 text-center">
        <ExclamationTriangleIcon className="text-help-center-warning h-20" />

        <p className="text-2xl font-bold">
          {t("pages.helpCenter.activeAppleSubscription")}
        </p>

        <p>{t("pages.helpCenter.cancelationApple.followAppleInstructions")}</p>

        <div className="rounded-lg border border-[#E2A2A2] bg-[#E2A2A215] p-5 text-center">
          <Link className="break-all underline" target="_blank" to={appleUrl}>
            {appleUrl}
          </Link>
        </div>
      </div>
    </LayoutWhite>
  );
}
